import type { Coordinates } from "./types";

// This file previously exported a `CHONBURI` campus config and a
// `CHULA = CHONBURI` alias inherited from the Chonburi fork. Nothing in the
// application imported either — they existed only so that stray legacy
// imports would still compile — and they had a test file while SIKHIO, the
// config that actually ships, had none. Both were removed rather than kept
// as back-compat shims: a back-compat alias for a caller that does not exist
// is dead weight that outlives the reason it was added.

export interface CampusConfig {
  id: string;
  name: { en: string; th: string; zh: string };
  center: Coordinates;
  innerBounds: [Coordinates, Coordinates];
  outerBounds: [Coordinates, Coordinates];
  surroundingRoads: string[];
  defaultView: {
    longitude: number;
    latitude: number;
    zoom: number;
    pitch: number;
    bearing: number;
  };
}

export const SIKHIO: CampusConfig = {
  id: "sikhio-city",
  name: {
    en: "Sikhio Town Municipality",
    th: "เทศบาลเมืองสีคิ้ว",
    zh: "斯基哈市镇",
  },
  // Sikhio Town Municipality (เทศบาลเมืองสีคิ้ว) — 11.63 km²
  // Inland gateway town at the foot of Khao Yai massif.
  // Centre on the commercial core near Highway 2 / Mittraphap Road
  // and the SRT Northeastern Line station.
  center: [101.7233, 14.8917],
  innerBounds: [
    [101.69, 14.87], // SW — ~4 km from centre
    [101.75, 14.91], // NE — ~4 km from centre
  ],
  outerBounds: [
    // West/south extended to keep เขื่อนลำตะคอง (dam crest 14.865, 101.562)
    // and the full reservoir pool inside the pannable area — the dam is the
    // dashboard's headline asset.
    [101.50, 14.76],
    [101.79, 14.96],
  ],
  surroundingRoads: [
    "ถนนมิตรภาพ (ทางหลวงหมายเลข 2)",
    "ทางหลวงหมายเลข 201 (สีคิ้ว-ชัยภูมิ)",
    "ทางหลวงหมายเลข 205 (สีคิ้ว-ด่านขุนทด)",
    "ทางหลวงชนบท นม.3032",
    "ทางหลวงชนบท นม.3044",
  ],
  // Zoom 13.5 ≈ 3 km across — shows the full 11.63 km² municipal area.
  // Pitch 45° gives readable 3D depth for a flat agricultural town.
  defaultView: {
    longitude: 101.7233,
    latitude: 14.8917,
    zoom: 13.5,
    pitch: 45,
    bearing: 0,
  },
};
